import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import {
  TaskDelay,
  TaskStatus,
  TaskTargetType,
  TaskType,
} from './predefined-task';

export interface TaskProps {
  dietitianId?: string;
  type: TaskType;
  description: string;
  delay: TaskDelay | undefined;
  targetType: TaskTargetType;
  status: TaskStatus;
  createdAt: Date;
  updatedAt: Date | undefined;
}

export class TaskId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): TaskId {
    return new TaskId(id);
  }
}

export class Task extends Entity<TaskProps> {
  get taskId(): TaskId {
    return TaskId.create(this.id);
  }

  get dietitianId(): string | undefined {
    return this.props.dietitianId;
  }

  get type(): TaskType {
    return this.props.type;
  }

  set type(value: TaskType) {
    this.props.type = value;
  }

  get description(): string {
    return this.props.description;
  }

  set description(description: string) {
    this.props.description = description;
  }

  get delay(): TaskDelay | undefined {
    return this.props.delay;
  }

  set delay(delay: TaskDelay | undefined) {
    this.props.delay = delay;
  }

  get targetType(): TaskTargetType {
    return this.props.targetType;
  }

  set targetType(taskTargetType: TaskTargetType) {
    this.props.targetType = taskTargetType;
  }

  get status(): TaskStatus {
    return this.props.status;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  get isPredefinedTask(): boolean {
    return false;
  }

  private constructor(props: TaskProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: TaskProps): Task {
    return Task.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: TaskProps, id?: UniqueEntityID): Task {
    return new Task(props, id);
  }
}
